import { PropTypes } from "aem/ComponentWrapper";

export default {
  title: "Request Consultation Dialog",
  type: "rh/components/content/rh-request-consultation-dialog",
  config: {
    emptyLabel: "Request Consultation Dialog",
    isEmpty: (_: PropTypes) => false
  }
};
